const DOMAIN = "https://www.adriaticasrlbolognacostruzioni.com";

export const ARTICLES = {
  "bonus-ristrutturazioni": {
    slug: "bonus-ristrutturazioni",
    category: "Bonus edilizi",
    metaTitle: "Bonus Ristrutturazioni: Cosa Sapere Prima di Iniziare | Adriatica Bologna",
    metaDescription:
      "Guida al bonus ristrutturazioni: quali lavori danno diritto alla detrazione, come funziona il bonifico parlante e come partire con il piede giusto. Adriatica S.r.l., impresa edile a Bologna.",
    title: "Bonus ristrutturazioni: cosa sapere prima di iniziare i lavori",
    excerpt:
      "Detrazioni, bonifico parlante, documenti da conservare: la guida essenziale per chi sta per ristrutturare casa e vuole sfruttare le agevolazioni fiscali.",
    date: "20 ottobre 2026",
    readTime: "4 min",
    heroImg:
      "https://images.pexels.com/photos/30211382/pexels-photo-30211382.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    heroAlt: "Interno ristrutturato con detrazioni fiscali — guida Adriatica",
    sections: [
      {
        h: "Cos'è la detrazione per le ristrutturazioni",
        paragraphs: [
          "Chi esegue lavori di ristrutturazione edilizia sulla propria abitazione può portare in detrazione una parte della spesa sostenuta, recuperandola nel tempo tramite la dichiarazione dei redditi. Aliquote, limiti di spesa e requisiti vengono aggiornati ogni anno dalla Legge di Bilancio: per questo è fondamentale verificare la normativa vigente al momento dell'avvio dei lavori.",
          "In generale, l'agevolazione riguarda gli interventi di manutenzione straordinaria, restauro e risanamento conservativo, ristrutturazione edilizia e — per le parti comuni condominiali — anche la manutenzione ordinaria.",
        ],
      },
      {
        h: "Quali lavori rientrano nell'agevolazione",
        paragraphs: [
          "Rientrano tipicamente il rifacimento di impianti idraulici ed elettrici, la sostituzione di pavimenti e rivestimenti, le opere murarie come l'apertura di nuove aperture o la ridistribuzione degli spazi, il rifacimento del bagno e molti altri interventi che modificano o migliorano l'immobile.",
          "Attenzione: non tutti i lavori sono agevolabili e le regole cambiano nel tempo. Prima di partire, conviene sempre verificare insieme a un professionista quali voci del preventivo possono beneficiare della detrazione.",
        ],
      },
      {
        h: "Il bonifico parlante e i documenti da conservare",
        paragraphs: [
          "Per accedere alla detrazione, i pagamenti devono essere tracciati con il cosiddetto \"bonifico parlante\": un bonifico bancario o postale che riporta causale dedicata alle agevolazioni edilizie, codice fiscale di chi paga e partita IVA dell'impresa che esegue i lavori.",
          "Vanno conservati con cura fatture, bonifici, eventuali comunicazioni e titoli edilizi. Un'impresa seria ti consegna tutta la documentazione ordinata a fine lavori: è uno dei vantaggi concreti del lavorare con professionisti.",
        ],
      },
      {
        h: "Perché partire dal preventivo giusto",
        paragraphs: [
          "Un preventivo dettagliato, con le voci di lavorazione separate e descritte, semplifica tutto: la pratica fiscale, il controllo dei costi e il confronto con altre offerte. Noi di Adriatica prepariamo preventivi chiari e ti affianchiamo nella parte documentale delle detrazioni, dal primo sopralluogo alla consegna.",
        ],
      },
    ],
  },
  "ecobonus-efficientamento": {
    slug: "ecobonus-efficientamento",
    category: "Bonus edilizi",
    metaTitle: "Ecobonus ed Efficientamento Energetico: Quando Conviene | Adriatica Bologna",
    metaDescription:
      "Ecobonus ed efficientamento energetico: cappotto, infissi, climatizzazione e fotovoltaico. Quando conviene intervenire e come funzionano le detrazioni. Adriatica S.r.l. Bologna.",
    title: "Ecobonus ed efficientamento energetico: quando conviene intervenire",
    excerpt:
      "Cappotto termico, infissi, climatizzazione e fotovoltaico: gli interventi che tagliano le bollette e possono beneficiare delle agevolazioni fiscali.",
    date: "20 ottobre 2026",
    readTime: "4 min",
    heroImg:
      "https://images.unsplash.com/photo-1770391949357-3c27554d3a78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBpbnRlcmlvciUyMHJlbm92YXRpb24lMjBsdXh1cnklMjBhcGFydG1lbnQlMjBzb2xhciUyMHBhbmVsJTIwYmx1ZXByaW50fGVufDB8fHx8MTc5MjQzOTQzNHww&ixlib=rb-4.1.0&q=85",
    heroAlt: "Efficientamento energetico e fotovoltaico — guida Adriatica",
    sections: [
      {
        h: "Cos'è l'ecobonus",
        paragraphs: [
          "L'ecobonus è l'agevolazione fiscale dedicata agli interventi di riqualificazione energetica degli edifici: lavori che riducono i consumi e migliorano il comfort, dall'isolamento delle pareti alla sostituzione degli impianti. Come per tutte le agevolazioni edilizie, percentuali, tetti di spesa e condizioni vengono definiti anno per anno: verifica sempre la normativa vigente prima di programmare l'intervento.",
        ],
      },
      {
        h: "Gli interventi che danno i risultati migliori",
        paragraphs: [
          "Tra gli interventi più efficaci ci sono il cappotto termico, la sostituzione di infissi e serramenti, l'installazione di impianti di climatizzazione efficienti e il fotovoltaico. Il fotovoltaico in particolare unisce due vantaggi: riduce subito la bolletta e aumenta il valore dell'immobile.",
          "La scelta giusta dipende dall'edificio: per questo il primo passo è sempre un sopralluogo tecnico, che permette di capire dove si disperde energia e quali lavori hanno la priorità.",
        ],
      },
      {
        h: "Comfort e risparmio, non solo detrazione",
        paragraphs: [
          "Le agevolazioni fiscali sono un incentivo importante, ma il vero ritorno arriva ogni mese: una casa ben isolata e con impianti efficienti consuma meno, d'inverno e d'estate, e si vive meglio. In fase di ristrutturazione, integrare gli interventi energetici nel cantiere costa molto meno che farli in un secondo momento.",
        ],
      },
      {
        h: "Documenti e asseverazioni",
        paragraphs: [
          "Gli interventi di efficientamento energetico richiedono spesso documentazione tecnica specifica, come l'asseverazione di un tecnico abilitato e la trasmissione telematica all'ENEA. Con la formula chiavi in mano ci occupiamo noi del coordinamento con i professionisti necessari, così non devi gestire nulla.",
        ],
      },
    ],
  },
  "chiavi-in-mano-errori": {
    slug: "chiavi-in-mano-errori",
    category: "Guide",
    metaTitle: "Ristrutturare Chiavi in Mano: 5 Errori da Evitare | Adriatica Bologna",
    metaDescription:
      "Ristrutturare con la formula chiavi in mano: gli errori più comuni da evitare, dai preventivi non confrontabili ai tempi sottovalutati. Adriatica S.r.l. Bologna.",
    title: "Ristrutturare chiavi in mano: gli errori da evitare",
    excerpt:
      "Coordinare da soli cinque imprese, preventivi impossibili da confrontare, tempi che si allungano: gli errori classici di chi ristruttura e come evitarli.",
    date: "20 ottobre 2026",
    readTime: "4 min",
    heroImg:
      "https://images.pexels.com/photos/7641932/pexels-photo-7641932.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    heroAlt: "Progettazione chiavi in mano senza errori — guida Adriatica",
    sections: [
      {
        h: "Errore 1 — Coordinare da soli imprese diverse",
        paragraphs: [
          "Idraulico, elettricista, muratore, imbianchino: quando ogni lavorazione è affidata a un'impresa diversa, il coordinamento ricade su di te. Basta un ritardo di uno per bloccare tutti gli altri. Con un unico interlocutore che gestisce il cantiere, le responsabilità sono chiare e i tempi si rispettano.",
        ],
      },
      {
        h: "Errore 2 — Confrontare preventivi non confrontabili",
        paragraphs: [
          "Due preventivi con lo stesso prezzo finale possono includere lavorazioni completamente diverse: materiali, finiture, voci escluse. Chiedi sempre preventivi dettagliati voce per voce e verifica cosa è compreso e cosa no. Un prezzo basso con molte esclusioni diventa quasi sempre il più caro a fine lavori.",
        ],
      },
      {
        h: "Errore 3 — Sottovalutare i tempi",
        paragraphs: [
          "Ogni cantiere ha imprevisti, ma un cronoprogramma serio li mette in conto. Diffida di chi promette tempi irrealistici per vincere il lavoro: meglio una data di consegna onesta e rispettata che una promessa che slitta di mesi.",
        ],
      },
      {
        h: "Errore 4 — Dimenticare la parte fiscale",
        paragraphs: [
          "Detrazioni e agevolazioni hanno regole precise su pagamenti e documenti: scoprirle a lavori finiti può significare perdere migliaia di euro di recupero fiscale. La documentazione va preparata prima e durante il cantiere, non dopo.",
        ],
      },
      {
        h: "La soluzione: un unico referente",
        paragraphs: [
          "La formula chiavi in mano di Adriatica nasce proprio per questo: consulenza e progettazione, direzione lavori, gestione del cantiere e controllo qualità con un unico interlocutore, dalla progettazione alla consegna. Tu segui l'avanzamento, al resto pensiamo noi.",
        ],
      },
    ],
  },
  "costi-ristrutturazione": {
    slug: "costi-ristrutturazione",
    category: "Guide",
    metaTitle: "Quanto Costa Ristrutturare: Da Cosa Dipende il Prezzo | Adriatica Bologna",
    metaDescription:
      "Quanto costa ristrutturare un appartamento? Da cosa dipende il prezzo: dimensioni, impianti, materiali e imprevisti. Guida Adriatica S.r.l., impresa edile a Bologna.",
    title: "Quanto costa ristrutturare: da cosa dipende davvero il prezzo",
    excerpt:
      "Dimensioni, impianti, materiali e imprevisti: le voci che compongono il costo di una ristrutturazione e come leggere un preventivo senza sorprese.",
    date: "20 ottobre 2026",
    readTime: "4 min",
    heroImg:
      "https://images.pexels.com/photos/36676879/pexels-photo-36676879.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    heroAlt: "Villa moderna al tramonto — costi di ristrutturazione, guida Adriatica",
    sections: [
      {
        h: "Non esiste un prezzo al metro quadro valido per tutti",
        paragraphs: [
          "La domanda più frequente è \"quanto costa ristrutturare al metro quadro?\". La risposta onesta è: dipende. Due appartamenti identici possono richiedere cifre molto diverse in base allo stato dell'immobile, alle lavorazioni richieste e al livello delle finiture. Ogni cifra letta online va presa come indicazione di massima, mai come preventivo.",
        ],
      },
      {
        h: "Le voci che pesano di più sul costo",
        paragraphs: [
          "Il rifacimento degli impianti (idraulico ed elettrico) è spesso la voce più significativa, seguito dalle opere murarie, dal rifacimento dei bagni e dalle finiture: pavimenti, porte, sanitari, rivestimenti. Spostare un bagno o abbattere una parete portante cambia molto il conto rispetto a un semplice rinnovo estetico.",
          "Anche la scelta dei materiali fa la differenza: a parità di lavorazione, finiture di pregio possono far variare sensibilmente il totale.",
        ],
      },
      {
        h: "Gli imprevisti si mettono in conto",
        paragraphs: [
          "In ogni ristrutturazione possono emergere imprevisti una volta aperto il cantiere: impianti da rifare, umidità nascosta, strutture da rinforzare. Un preventivo serio lo dice chiaramente e un'impresa seria ti avvisa subito, con costi e alternative, prima di procedere.",
        ],
      },
      {
        h: "Come leggere un preventivo",
        paragraphs: [
          "Un buon preventivo è dettagliato voce per voce: lavorazioni, quantità, materiali, tempi. Solo così puoi confrontare offerte diverse e capire cosa stai davvero pagando. Noi di Adriatica partiamo sempre da un sopralluogo gratuito: è l'unico modo per darti un prezzo reale invece di una stima generica.",
        ],
      },
    ],
  },
  "tempi-ristrutturazione": {
    slug: "tempi-ristrutturazione",
    category: "Guide",
    metaTitle: "Quanto Dura una Ristrutturazione: Tempi Reali di un Cantiere | Adriatica Bologna",
    metaDescription:
      "Quanto dura ristrutturare un bagno, un appartamento o una villa? Le fasi del cantiere, cosa influenza i tempi e come si rispettano. Guida Adriatica S.r.l. Bologna.",
    title: "Quanto dura una ristrutturazione: i tempi reali di un cantiere",
    excerpt:
      "Dalle poche settimane di un bagno ai mesi di un appartamento completo: come si compongono i tempi di una ristrutturazione e perché un cronoprogramma serio fa la differenza.",
    date: "20 ottobre 2026",
    readTime: "4 min",
    heroImg:
      "https://images.unsplash.com/photo-1778074762022-c33cc42f79ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwaGFyZGhhdCUyMGVuZ2luZWVycyUyMGJsdWVwcmludHN8ZW58MHx8fHwxNzkyNDM5NDI3fDA&ixlib=rb-4.1.0&q=85",
    heroAlt: "Tecnici pianificano i tempi di cantiere — guida Adriatica",
    sections: [
      {
        h: "I tempi dipendono dalla dimensione del cantiere",
        paragraphs: [
          "Come indicazione generale: il rifacimento di un bagno si misura in poche settimane, la ristrutturazione completa di un appartamento in alcuni mesi, quella di una villa o di un edificio intero in tempi più lunghi. Sono stime di massima: lo stato dell'immobile, le lavorazioni richieste e i materiali scelti spostano sempre il calendario.",
        ],
      },
      {
        h: "Le fasi di una ristrutturazione",
        paragraphs: [
          "Ogni cantiere segue un ordine preciso: demolizioni e rimozioni, nuove tracce e impianti, opere murarie e massetti, poi finiture, pavimenti, sanitari e infine pulizie e consegna. Le fasi si susseguono in sequenza: un ritardo all'inizio si trascina su tutte le altre, per questo il coordinamento è decisivo.",
        ],
      },
      {
        h: "Cosa può allungare i tempi",
        paragraphs: [
          "Imprevisti in cantiere, tempi di consegna di materiali particolari, modifiche decise a lavori in corso e pratiche amministrative sono le cause più comuni di ritardo. Alcune non si possono evitare, ma si possono gestire: l'importante è saperlo subito e ricalibrare il programma insieme.",
        ],
      },
      {
        h: "Come si rispettano i tempi",
        paragraphs: [
          "Con un cronoprogramma scritto prima dell'inizio e un unico referente che coordina tutte le lavorazioni. Nella formula chiavi in mano di Adriatica tempi e costi sono concordati all'inizio e monitorati durante tutto il cantiere: tu segui l'avanzamento, senza dover rincorrere nessuno.",
        ],
      },
    ],
  },
};

export const ARTICLE_LIST = Object.values(ARTICLES);

export { DOMAIN };
